var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(['admin', 'store'].includes(_vm.user ? _vm.user.role : null))?_c('navbar'):_vm._e(),(['delivery'].includes(_vm.user ? _vm.user.role : null))?_c('mobile-navbar'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }